export class Verify2FATimerController {
    private count: number = 0;
    private RedirectTimerId: string = "#logintimes";
    private timerId: number | undefined;

    constructor(initialSeconds?: number) {
        this.count = initialSeconds || 0;
    }

    start(): void {
        const timerElem = $(this.RedirectTimerId);
        if (timerElem.length > 0) {
            // Read from data attribute if count wasn't passed in constructor
            if (this.count === 0) {
                const secondsAttr = timerElem.data("timer-seconds");
                this.count = parseInt(secondsAttr) || 300;
            }

            this.countDown();
        }
    }

    countDown(): void {
        const timerElem = $(this.RedirectTimerId);

        if (timerElem.length > 0) {
            if (this.count > 0) {
                const minutes = Math.floor(this.count / 60);
                const seconds = this.count % 60;
                const formattedTime =
                    (minutes < 10 ? "0" : "") + minutes + ":" +
                    (seconds < 10 ? "0" : "") + seconds;

                timerElem.html(formattedTime);
                this.count--;

                this.timerId = window.setTimeout(() => this.countDown(), 1000);
            } else {
                timerElem.html("Time's up!");
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = undefined;
                }
            }
        }
    }

    reset(newSeconds: number): void {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = undefined;
        }
        this.count = newSeconds;
        this.countDown();
    }
}

// Auto-initialize when DOM is ready
$(function () {
    const timerController = new Verify2FATimerController();
    timerController.start();
});
